/** True when running inside the packaged/dev Electron shell (preload exposed). */
export function isElectronApp(): boolean {
  return typeof window !== 'undefined' && !!(window as Window & { electronAPI?: unknown }).electronAPI;
}
